import React, { useRef, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  DialogTitle,
  Box,
  Typography,
} from "@mui/material";
import Cropper from "react-cropper";

const ImageCropDialog = ({
  open,
  initialSrc,
  onCancel,
  onSave,
  cropWidth = 500,
  cropHeight = 500,
}) => {
  const cropperRef = useRef(null);
  const handleSave = async () => {
    const cropper = cropperRef.current?.cropper;
    if (!cropper) return;
    // getCroppedCanvas and convert to blob
    try {
      const canvas = cropper.getCroppedCanvas({
        width: cropWidth,
        height: cropHeight,
        fillColor: "#fff",
      });
      if (!canvas) {
        return;
      }
      canvas.toBlob(
        (blob) => {
          if (!blob) {
            console.error("Failed to produce blob from canvas");
            return;
          }
          const file = new File([blob], `cropped-${Date.now()}.jpg`, {
            type: "image/jpeg",
          });
          onSave(file);
        },
        "image/jpeg",
        0.9
      );
    } catch (err) {
      console.error("Crop save error:", err);
    }
  };

  return (
    <Dialog open={open} maxWidth="md" fullWidth onClose={onCancel}>
      <DialogTitle sx={{ textAlign: "center" }}>Crop Image</DialogTitle>
      <DialogContent sx={{ height: { xs: 360, md: 480 } }}>
        {initialSrc ? (
          <Cropper
            src={initialSrc}
            style={{ height: "100%", width: "100%" }}
            aspectRatio={1}
            guides={false}
            ref={cropperRef}
            viewMode={1}
            dragMode="move"
            background={false}
            autoCropArea={1}
            responsive
            checkOrientation={true}
          />
        ) : (
          <Box
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Typography variant="body2">No image to crop</Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", mb: 2 }}>
        <Button variant="outlined" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSave}>
          Crop & Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImageCropDialog;
